import { ShallowClonedTypeFor } from 'src/models/common';
import { EPrescriptionQuotationFormType } from './e-prescription-quotation';
import * as Yup from 'yup';
import { reverseShape } from 'Helpers/reverse-shape';

const fileObjectValidation = Yup.object({});

const ePrescriptionQuotationSchemaObject: ShallowClonedTypeFor<
  EPrescriptionQuotationFormType,
  any
> = {
  files: Yup.array(fileObjectValidation).required().min(1),
};

export const ePrescriptionQuotationSchema = Yup.object(
  reverseShape(ePrescriptionQuotationSchemaObject),
);
